{
  "es-ES": {
    "model": {
      "profile": {
        "id": "ID de usuario",
        "userName": "Nombre de usuario",
        "email": "Dirección de correo electrónico",
        "emailConfirmed": "Correo electrónico confirmado",
        "phoneNumber": "Número de teléfono",
        "phoneNumberConfirmed": "Número de teléfono confirmado.",
        "twoFactorEnabled": "Autenticación de dos factores activada.",
        "lockoutEnd": "Fin del bloqueo.",
        "lockoutEnabled": "Bloqueo habilitado",
        "accessFailedCount": "Número de intentos de acceso fallidos.",
        "firstName": "Nombre de pila",
        "lastName": "Apellido",
        "picture": "Imagen de avatar.",
        "organisationName": "Organización",
        "name": "Nombre",
        "roles": "Roles"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Confirmado"
      },
      "action": {
        "resetPassword.tooltip": "Envíe al usuario las instrucciones para restablecer la contraseña por correo electrónico."
      },
      "message": {
        "resetPassword.success": "Se ha enviado un correo electrónico al usuario con instrucciones para restablecer su contraseña."
      }
    }
  }
}